import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import NavigationLink from 'app/components/layout/AppLayout/NavigationLink';
import { useGeneralState } from 'app/state/GeneralContext/hooks';

// Local Typings
interface Props {
  onClick: () => void;
}

// Component Definition
const ToggleButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation('components');

  const { isSideNavOpen } = useGeneralState();

  return (
    <NavigationLink
      activePaths={[]}
      iconName={isSideNavOpen ? 'caret-double-left' : 'caret-double-right'}
      id="toggle-side-nav"
      isSideNavOpen={isSideNavOpen}
      label={t('layout.sideNav.collapseButton', 'Collapse')}
      onClick={onClick}
    />
  );
};

export default ToggleButton;
